import { useEffect, useState } from "react";
import {
	query,
	collection,
	orderBy,
	onSnapshot,
	where,
} from "firebase/firestore";
import { firebaseDB } from "../../firebase";
import { BudgetGroupInvite } from "../../types/budgethelper";
import { useUser } from "../../auth/userContext";

export const useGetInvites = () => {
	const [invites, setInvites] = useState<BudgetGroupInvite[]>([]);
	const { userProfile, loading } = useUser();
	
	const invitesCollectionRef = collection(firebaseDB, "invites");

	const getInvites = async () => {
		let unsubscribe: () => void = () => {};
		try {
			const queryInvites = query(
				invitesCollectionRef,
				where("invitedUserId", "==", userProfile!.userId),
				orderBy("timestamp", "desc")
			);

			unsubscribe = onSnapshot(queryInvites, (snapshot) => {
				let docs: BudgetGroupInvite[] = [];
				snapshot.forEach((doc) => {
					const data = doc.data();
					const id = doc.id;

					docs.push({ ...data, id } as BudgetGroupInvite);
				});

				setInvites(docs);
			});
		} catch (err) {
			console.error(err);
		}

		return () => unsubscribe();
	};

	useEffect(() => {
		if (!userProfile || loading) return;
		getInvites();
	}, [loading]);

	return { invites };
};